export default __webpack_public_path__ + "static/media/map.782ef881.png";